import { render, staticRenderFns } from "./olympicGamesFull_SOG.vue?vue&type=template&id=575368f1"
import script from "./olympicGamesFull_SOG.vue?vue&type=script&lang=js"
export * from "./olympicGamesFull_SOG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports